<div class="sam-margin sam-form-control sam-form-control-full-width">
   <label fxFlex="1 1 auto" class="shortcutName k-form-field k-form-field-label">
      <span
         [innerHtml]="
            shortcutTyp.translationKey
               | translate: { columnToDial: column | directoryColumnTitle | async }
               | highlightText$: searchValue$:true
               | async
               | safeHtml
         "
      >
      </span>
   </label>

   <div class="container k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
      <input
         [disabled]="disabled"
         (input)="comboChanged($event.target.value)"
         [value]="hotkeyCombo$ | async"
         fxFlex="1 1 auto"
         (focus)="startRecording()"
         (focusout)="stopRecording()"
         kendoTextBox
         class="item"
      />
      <fa-icon
         [style.color]="'transparent'"
         [icon]="recordIcon"
         [class.is-recording]="isRecording"
         [pulse]="isRecording"
      ></fa-icon>
      <fa-icon class="clear-hotkey sam-margin-left" [icon]="clearFilterIcon" (click)="clearShortcut()"> </fa-icon>
   </div>
</div>
